//  日期格式化
export function formatDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return {
    year,
    month,
    day,
    hours,
    minutes,
    seconds
  }
}
export function isDateIntervalExceeds31Days(date1, date2) {
  // 计算两个日期之间的毫秒数差值
  const diffInMilliseconds = Math.abs(date2 - date1)

  // 将毫秒数差值转换为天数
  const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24))

  // 检查间隔是否超过31天
  return diffInDays > 31
}

export function secondsToHoursMinutes(seconds) {
  // 计算小时数
  var hours = Math.floor(seconds / 3600)
  // 计算剩余的秒数
  var remainingSeconds = seconds % 3600
  // 计算分钟数
  var minutes = Math.round(remainingSeconds / 60)
  // 如果分钟数超过59，则小时数加一
  if (minutes > 59) {
    hours++
    minutes = 0 // 将分钟数设为0，因为这些被算到小时数里了
  }

  return `${hours}时${minutes}分`
}
